<template>
    <a-select
        :get-popup-container="getPopupContainer"
        placeholder="请输入"
        mode="tags"
        :value="valueArray"
        :open="false"
        @update:value="onUpdateValue"
        @search="onSearch"
        style="width: 100%"
    />
</template>

<script>
import {computed} from "vue";
import {message} from "ant-design-vue";

export default {
    name: "TagsInput",
    emits: ["update:value"],
    props: {
        value: {
            type: String,
            default: "",
        },
    },
    setup(props, {emit}) {
        const valueArray = computed(() =>
            props.value ? props.value.split(",") : []
        );
        const onUpdateValue = (val) => {
            let value = val.join(",");
            emit("update:value", value);
        };
        const onSearch = (val) => {
            if (val.indexOf(',') > -1) {
                message.warning('请不要输入英文逗号“,”')
            }
        }
        return {
            valueArray,
            onUpdateValue,
            onSearch,
        };
    },
};
</script>

<style scoped>
</style>
